import { render } from "./Main.vue?vue&type=template&id=3f1289ee"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=3f1289ee&lang=css"

import exportComponent from "H:\\Productions\\CS\\inc\\helpers\\cs-restaurants\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__